import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { db } from '../../services/firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';
import StatCard from '../../components/common/StatCard';
import { MdBook, MdPending, MdCheckCircle, MdCancel, MdVideoLibrary, MdAssignment } from 'react-icons/md';

const TeacherOverview = () => {
  const { userProfile } = useAuth();
  const [stats, setStats] = useState({
    subjects: 0,
    pendingLessons: 0,
    approvedLessons: 0,
    rejectedLessons: 0,
    totalLessons: 0,
    totalQuizzes: 0
  });

  useEffect(() => {
    const fetchStats = async () => {
      if (!userProfile) return;

      const subjectsCount = userProfile.assignedSubjects?.length || 0;
      
      try {
        const pendingRef = collection(db, 'content_approvals');
        const qPending = query(pendingRef, where('teacherId', '==', userProfile.uid), where('status', '==', 'pending'));
        const pendingSnap = await getDocs(qPending);
        
        const qApproved = query(pendingRef, where('teacherId', '==', userProfile.uid), where('status', '==', 'approved'));
        const approvedSnap = await getDocs(qApproved);

        const qRejected = query(pendingRef, where('teacherId', '==', userProfile.uid), where('status', '==', 'rejected'));
        const rejectedSnap = await getDocs(qRejected);

        const qLessons = query(pendingRef, where('teacherId', '==', userProfile.uid), where('type', '==', 'lesson'));
        const lessonsSnap = await getDocs(qLessons);

        const qQuizzes = query(pendingRef, where('teacherId', '==', userProfile.uid), where('type', '==', 'quiz'));
        const quizzesSnap = await getDocs(qQuizzes);

        setStats({
          subjects: subjectsCount,
          pendingLessons: pendingSnap.size,
          approvedLessons: approvedSnap.size,
          rejectedLessons: rejectedSnap.size,
          totalLessons: lessonsSnap.size,
          totalQuizzes: quizzesSnap.size
        });
      } catch (err) {
        console.error("Error fetching stats", err);
      }
    };
    fetchStats();
  }, [userProfile]);

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <h1 className="text-3xl font-bold mb-2 text-darkNavy font-poppins">Teacher Overview</h1>
      <p className="mb-8 text-gray-600">Welcome back, {userProfile?.fullName || 'Teacher'}!</p>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-8">
        <StatCard
          title="Assigned Subjects"
          value={stats.subjects}
          icon={MdBook}
          color="#3B82F6"
        />
        <StatCard
          title="Total Lessons"
          value={stats.totalLessons}
          icon={MdVideoLibrary}
          color="#8B5CF6"
        />
        <StatCard
          title="Total Quizzes"
          value={stats.totalQuizzes}
          icon={MdAssignment}
          color="#EC4899"
        />
        <StatCard
          title="Approved Content"
          value={stats.approvedLessons}
          icon={MdCheckCircle}
          color="#10B981"
        />
        <StatCard
          title="Pending Approvals"
          value={stats.pendingLessons}
          icon={MdPending}
          color="#F59E0B"
        />
        <StatCard
          title="Rejected Content"
          value={stats.rejectedLessons}
          icon={MdCancel}
          color="#EF4444"
        />
      </div>
    </div>
  );
};

export default TeacherOverview;
